export const CHATTEL_DETAILS_SECTION_TITLE = 'Chattel Details';

export const CHATTEL_GROUP_TITLE = {
  HOME_DETAILS: 'Home Details',
  VALUE: 'Value',
  SALES_CONTRACT: 'Sales Contract',
  LOCATION: 'Location',
  DEALERSHIP: 'Dealership',
};

export const CHATTEL_HOME_TYPE_LABEL = {
  SingleWide: 'Single Wide',
  DoubleWide: 'Double Wide',
  TripleWide: 'Triple Wide',
};

export const CHATTEL_HOME_CONDITION_LABEL = {
  New: 'New',
  Used: 'Used',
  Repo: 'Repo',
};

export const CHATTEL_VALUE_SOURCE_LABEL = {
  Appraisal: 'Appraisal',
  Nada: 'NADA',
  Other: 'Other',
};

export const CHATTEL_FIELD_NAME = {
  MAKE: 'Make',
  MODEL: 'Model',
  SERIAL_NUMBER: 'Serial Number',
  HUD_LABEL: 'HUD Label',
  YEAR_BUILT: 'Year Built',
  HOME_TYPE: 'Home Type',
  CONDITION: 'Condition',
  HOME_VALUE: 'Home Value',
  APPRAISED_VALUE: 'Appraised Value',
  ORIGINAL_PRICE: 'Original Purchase Price',
  SALES_PRICE: 'Sales Price',
  SALES_TAX: 'Sales Tax',
  MHIT: 'MHIT',
  SITE_PLACEMENT: 'Site Placement',
  PARK_NAME: 'Park Name',
  LOT_NUMBER: 'Lot #',
  MONTHLY_LOT_RENT: 'Monthly Lot Rent',
  LANDOWNER_NAME: 'Landowner Name',
  LANDOWNER_PHONE: 'Landowner Phone',
  LAND_MONTHLY_PAYMENT: 'Monthly Land Payment',
  LOCATION_DESCRIPTION: 'Location / Legal Description',
  DEALERSHIP_NAME: 'Dealership Name',
  DEALERSHIP_ADDRESS: 'Dealership Address',
  DEALERSHIP_PHONE: 'Dealership Phone',
  DEALERSHIP_EMAIL: 'Dealership Email',
};

export const CHATTEL_GROUP_SKELETONS_LENGTH = 4;
